/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangeSubStateTourRequest } from '../../models/change-sub-state-tour-request';
import { Tour } from '../../models/tour';

export interface UpdateStartedSubState$Params {

/**
 * Id of a resource.
 */
  id: string;
      body: ChangeSubStateTourRequest
}

export function updateStartedSubState(http: HttpClient, rootUrl: string, params: UpdateStartedSubState$Params, context?: HttpContext): Observable<StrictHttpResponse<Tour>> {
  const rb = new RequestBuilder(rootUrl, updateStartedSubState.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Tour>;
    })
  );
}

updateStartedSubState.PATH = '/api/v1/tours/{id}/started_sub_state';
